import { Signal } from 'libs/signals';

const userActivationSignal = Signal({
  selectedUser: null,
  modalVisible: false,
  mode: null,
});

export default userActivationSignal;
